import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Solution(props) {
  return (
    <div className="services_solution  p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <div className="example" data-text="Cloud Solutions">
              <h2>Why Should You Choose Infrastructure Migration Services?</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Selecting infrastructure migration services gives your
              organization access to cutting-edge tools and experience in this
              highly complex yet rewarding journey of uplifting the digital
              infrastructure of your organization.
            </p>
            <p>
              Let us, together with our tailored solutions and experienced team,
              help you seamlessly transition to your more efficient, scale, and
              secure environments that ensure your long-term success and be
              competitive in the fast-changing digital landscape of today.
              Reasons to Choose Infrastructure Migration Services:
            </p>
            <div className="banner_content_txt mb-3">
              <ul>
                <li>Enhanced scalability</li>
                <li>Improved security</li>
                <li>Cost savings</li>
                <li>Increased agility</li>
                <li>Future-proofing</li>
              </ul>
            </div>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Solution;
